import Chores from "./Chores";
import Dish from "./Dish";

function App() {
  return <Dish />;
}

export default App;
